module.exports = __webpack_public_path__ + "img/354ab4b.jpg";